import {UiBaseIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><circle id=\"8ftrzjgu4a\" cx=\"12\" cy=\"12\" r=\"12\"></circle></defs><g fill=\"none\" fill-rule=\"evenodd\"><mask id=\"ghdfkp6wab\" fill=\"#fff\"><use xlink:href=\"#8ftrzjgu4a\"></use></mask><use xlink:href=\"#8ftrzjgu4a\" fill=\"#E6E6E6\"></use><g fill=\"#707070\" fill-rule=\"nonzero\" mask=\"url(#ghdfkp6wab)\"><path d=\"M6.548 17.119c.027-.204.049-.41.085-.611.28-1.48 1.063-2.637 2.307-3.508.861.804 1.875 1.228 3.06 1.226 1.18 0 2.193-.42 3.062-1.23.172.135.354.263.52.407 1.048.918 1.666 2.062 1.834 3.437.01.092.026.186.039.279v.336H6.545c.003-.112.003-.225.003-.336z\"></path><path d=\"M12.258 6.545c.215.042.435.07.643.129a3.235 3.235 0 0 1 2.357 2.768c.183 1.808-1.163 3.394-3.006 3.543-1.66.137-3.188-1.028-3.47-2.647-.302-1.73.796-3.341 2.536-3.721.141-.032.286-.048.429-.072h.511z\"></path></g></g>", 2)
  ])))
}
export default { render() { return h(UiBaseIcon, {icon: {render}, name: "user"}) } }